import React from "react";

import jwtDecode from "jwt-decode";

import Error500Page from "./Error500Page";
import PasswordReset from "../features/auth/PasswordReset";

import { useQuery } from "../libs/utils";

function WelcomePage() {
  const query = useQuery();
  const queryToken = query.get("token");

  let isToken = null;
  try {
    isToken = !!jwtDecode(queryToken);
  } catch (err) {
    console.log("invalid token: err", err);
  }

  return queryToken && isToken ? <PasswordReset /> : <Error500Page />;
}

export default WelcomePage;
